<template>
<div class="row">
    <fieldset style="text-align: left">
        <vs-tabs class="custom-tabs" alignment="fixed">
            <vs-tab label="Quick Facilitator Registration">
                <div class="row mt-5">
                    <b-card v-if="isForm">
                        <form @submit.prevent="quickRegistration">
                            <div class="form-group form-row">
                                <div class="col-sm-6 mb-2">
                                    <div class="floating-label">
                                        <input class="floating-input form-control" type="text" placeholder=" " v-model="name" autocomplete="off" @input="name = name.replace(/[^a-zA-Z\s]/g, '')" />
                                        <span class="lbl-label" style="
                                            float: right;
                                            padding: 0px 5px;
                                            margin-top: -30px;
                                            color: #ccc;
                                          ">
                                            <i class="material-icons" style="font-size: 20px">account_circle</i>
                                        </span>
                                        <label class="lbl-label">
                                            Facilitator Name
                                            <span style="color: rgba(255, 0, 0, 0.78)">*</span>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-sm-6 mb-2 mb-2">
                                    <div class="floating-label">
                                        <input class="floating-input form-control" v-mask="'(9999)-9999999'" type="text" placeholder=" " v-model="mobilenumber" />

                                        <span class="lbl-label" style="
                                            float: right;
                                            padding: 0px 5px;
                                            margin-top: -30px;
                                            color: #ccc;
                                          ">
                                            <i class="material-icons" style="font-size: 20px">call</i>
                                        </span>
                                        <label class="lbl-label">
                                            Contact
                                            <span style="color: rgba(255, 0, 0, 0.78)">*</span>
                                        </label>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label style="font-weight: 700" for="first">
                                            Department
                                        </label>
                                        <selectize id="select-state" class="text-capitalize" v-model="department" :settings="departmentSetting" :searchable="true">
                                            <option v-for="(item,index) in departmentArr" :key="index" :value="item.id" class="text-capitalize">
                                                {{item.title}}
                                            </option>
                                        </selectize>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label style="font-weight: 700" for="first">
                                            Designation
                                        </label>
                                        <selectize id="select-state" class="text-capitalize" v-model="designation" :settings="designationSetting" :searchable="true">
                                            <option v-for="(item,index) in designationArr" :key="index" :value="item.id" class="text-capitalize">
                                                {{item.title}}
                                            </option>
                                        </selectize>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label style="font-weight: 700" for="first">
                                            Nationality
                                            <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                        </label>
                                        <selectize id="select-state" class="text-capitalize" v-model="nationality" :searchable="true">
                                            <option v-for="(item,index) in nationalityArr" :key="index" :value="item.id" class="text-capitalize">
                                                {{item.name}}
                                            </option>
                                        </selectize>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label style="font-weight: 700" for="first">
                                            Qualification
                                            <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                        </label>
                                        <selectize id="select-state" class="text-capitalize" v-model="academicqualifications" :searchable="true">
                                            <option v-for="(item,index) in qualificationArr" :key="index" :value="item.id" class="text-capitalize">
                                                {{item.title}}
                                            </option>
                                        </selectize>
                                    </div>
                                </div>
                                <div class="col-sm-6 mt-2">
                                    <div class="floating-label">
                                        <input class="floating-input form-control" v-mask="'(99999) 9999999-9'" type="text" placeholder=" " v-model="cnic" autocomplete="off" :disabled="nationality != 1" />

                                        <span class="lbl-label" style="
                                            float: right;
                                            padding: 0px 5px;
                                            margin-top: -30px;
                                            color: #ccc;
                                          ">
                                            <i class="material-icons" style="font-size: 20px">credit_card</i>
                                        </span>
                                        <label class="lbl-label">
                                            CNIC
                                            <span v-if="nationality == 1" style="color: rgba(255, 0, 0, 0.78)">*</span>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-sm-6 mb-2 mt-2">
                                    <div class="floating-label">
                                        <input class="floating-input form-control" type="text" placeholder="" v-model="address" />

                                        <span class="lbl-label" style="
                                            float: right;
                                            padding: 0px 5px;
                                            margin-top: -30px;
                                            color: #ccc;
                                          ">
                                            <i class="material-icons" style="font-size: 20px">home</i>
                                        </span>
                                        <label class="lbl-label"> Address </label>
                                    </div>
                                </div>

                                <div class="col-sm-6 mb-2 mt-3">
                                    <div class="floating-label">
                                        <input class="floating-input form-control" v-model="passport" type="text" placeholder=" " />
                                        <span class="lbl-label" style="
                                            float: right;
                                            padding: 0px 5px;
                                            margin-top: -30px;
                                            color: #ccc;
                                          ">
                                            <i class="material-icons" style="font-size: 20px">credit_card</i>
                                        </span>
                                        <label class="lbl-label"> Passport </label>
                                    </div>
                                </div>
                                <div class="col-sm-6 mb-2 mt-3">
                                    <div class="floating-label">
                                        <input class="floating-input form-control" type="email" placeholder=" " v-model="email" />

                                        <span class="lbl-label" style="
                                            float: right;
                                            padding: 0px 5px;
                                            margin-top: -30px;
                                            color: #ccc;
                                          ">
                                            <i class="material-icons" style="font-size: 20px">email</i>
                                        </span>
                                        <label class="lbl-label">
                                            Email
                                            <span style="color: rgba(255, 0, 0, 0.78)">*</span>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-6 mb-2 mt-3">
                                    <div class="floating-label">
                                        <input class="floating-input form-control" v-model="code" type="text" placeholder=" " />

                                        <span class="lbl-label" style="
                                            float: right;
                                            margin-top: -25px;
                                            padding: 0px 5px;
                                            color: #ccc;
                                          ">
                                            <i class="material-icons" style="font-size: 20px">code</i>
                                        </span>
                                        <label class="lbl-label">
                                            Employee Code (This will use as password)
                                            <span style="color: rgba(255, 0, 0, 0.78)">*</span>
                                        </label>
                                    </div>
                                </div>

                                <div class="col-md-6 col-lg-6 mb-2 mt-3">
                                    <div style="padding-left: 5px; display: inline-flex; color: #1465a3">
                                        <label class="col-form-label" style="font-weight: 700;">
                                            Gender
                                            <span style="color:rgba(255, 0, 0, 0.78)">*</span>
                                        </label>
                                        <div style="margin: 7px 6px 2px 6px">
                                            <vs-radio v-model="gender" vs-name="radios1" vs-value="male">Male</vs-radio>
                                        </div>
                                        <div style="margin: 7px 6px 2px 6px">
                                            <vs-radio v-model="gender" vs-name="radios1" vs-value="female">Female</vs-radio>
                                        </div>
                                        <div style="margin: 7px 6px 2px 6px">
                                            <vs-radio v-model="gender" vs-name="radios1" vs-value="rather not say">Rather not say</vs-radio>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6 mt-3 mb-2">
                                    <div class="floating-label">
                                        <input class="floating-input form-control" hidden type="text" placeholder=" " v-model="role" />

                                        <span class="lbl-label" style="
                                            float: right;
                                            padding: 0px 5px;
                                            margin-top: -30px;
                                            color: #ccc;
                                          "></span>
                                    </div>
                                </div>
                            </div>

                            <div class="row text-right">
                                <div class="col-md-12">
                                    <b-button type="submit" class="btn btn-primary btn-sm" variant="primary">Save</b-button>
                                </div>
                            </div>
                        </form>
                    </b-card>
                    <b-card v-if="isEditForm" style="border: 1px dotted #07a7e14f">
                        <form @submit.prevent="submitEditForm">
                            <div class="form-group">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="floating-label">
                                            <input class="floating-input form-control" type="text" placeholder=" " v-model="name" @input="name = name.replace(/[^a-zA-Z\s]/g, '')" />
                                            <span class="lbl-label" style="
                                              float: right;
                                              padding: 0px 5px;
                                              margin-top: -30px;
                                              color: #ccc;
                                            ">
                                                <i class="material-icons" style="font-size: 20px">account_circle</i>
                                            </span>
                                            <label class="lbl-label">Facilitator Name</label>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 mt-3">
                                        <div class="floating-label">
                                            <input class="floating-input form-control" v-mask="'(9999)-9999999'" type="text" placeholder=" " v-model="mobilenumber" />

                                            <span class="lbl-label" style="
                                              float: right;
                                              padding: 0px 5px;
                                              margin-top: -30px;
                                              color: #ccc;
                                            ">
                                                <i class="material-icons" style="font-size: 20px">call</i>
                                            </span>
                                            <label class="lbl-label">Contact</label>
                                        </div>
                                    </div>
                                    <div class="col-md-6 mt-2">
                                        <div class="form-group">
                                            <label style="font-weight: 700" for="first">
                                                Department
                                            </label>
                                            <selectize id="select-state" class="text-capitalize" v-model="department" :settings="departmentSetting" :searchable="true">
                                                <option v-for="(item,index) in departmentArr" :key="index" :value="item.id" class="text-capitalize">
                                                    {{item.title}}
                                                </option>
                                            </selectize>
                                        </div>
                                    </div>
                                    <div class="col-md-6 mt-2">
                                        <div class="form-group">
                                            <label style="font-weight: 700" for="first">
                                                Designation
                                            </label>
                                            <selectize id="select-state" class="text-capitalize" v-model="designation" :settings="designationSetting" :searchable="true">
                                                <option v-for="(item,index) in designationArr" :key="index" :value="item.id" class="text-capitalize">
                                                    {{item.title}}
                                                </option>
                                            </selectize>
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label style="font-weight: 700" for="first">
                                                Nationality
                                                <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                            </label>
                                            <selectize id="select-state" class="text-capitalize" v-model="nationality" :searchable="true">
                                                <option v-for="(item,index) in nationalityArr" :key="index" :value="item.id" class="text-capitalize">
                                                    {{item.name}}
                                                </option>
                                            </selectize>
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label style="font-weight: 700" for="first">
                                                Qualification
                                                <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                            </label>
                                            <selectize id="select-state" class="text-capitalize" v-model="academicqualifications" :searchable="true">
                                                <option v-for="(item,index) in qualificationArr" :key="index" :value="item.id" class="text-capitalize">
                                                    {{item.title}}
                                                </option>
                                            </selectize>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="floating-label">
                                            <input class="floating-input form-control" v-mask="'(99999) 9999999-9'" type="text" placeholder=" " v-model="cnic" :disabled="nationality != 1" />

                                            <span class="lbl-label" style="
                                              float: right;
                                              padding: 0px 5px;
                                              margin-top: -30px;
                                              color: #ccc;
                                            ">
                                                <i class="material-icons" style="font-size: 20px">credit_card</i>
                                            </span>
                                            <label class="lbl-label">CNIC</label>
                                        </div>
                                    </div>

                                    <div class="col-sm-6 mb-2 mt-3">
                                        <div class="floating-label">
                                            <input class="floating-input form-control" type="text" placeholder="" v-model="address" />

                                            <span class="lbl-label" style="
                                            float: right;
                                            padding: 0px 5px;
                                            margin-top: -30px;
                                            color: #ccc;
                                          ">
                                                <i class="material-icons" style="font-size: 20px">home</i>
                                            </span>
                                            <label class="lbl-label"> Address </label>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 mt-3">
                                        <div class="floating-label">
                                            <input class="floating-input form-control" v-model="passport" type="text" placeholder=" " />
                                            <span class="lbl-label" style="
                                              float: right;
                                              padding: 0px 5px;
                                              margin-top: -30px;
                                              color: #ccc;
                                            ">
                                                <i class="material-icons" style="font-size: 20px">credit_card</i>
                                            </span>
                                            <label class="lbl-label">Passport</label>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 mt-3">
                                        <div class="floating-label">
                                            <input class="floating-input form-control" disabled type="email" placeholder=" " v-model="email" />

                                            <span class="lbl-label" style="
                                              float: right;
                                              padding: 0px 5px;
                                              margin-top: -30px;
                                              color: #ccc;
                                            ">
                                                <i class="material-icons" style="font-size: 20px">email</i>
                                            </span>
                                            <label class="lbl-label">Email</label>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-lg-6 mt-3">
                                        <div class="floating-label">
                                            <input class="floating-input form-control" v-model="code" type="text" placeholder=" " />

                                            <span class="lbl-label" style="
                                              float: right;
                                              margin-top: -25px;
                                              padding: 0px 5px;
                                              color: #ccc;
                                            ">
                                                <i class="material-icons" style="font-size: 20px">code</i>
                                            </span>
                                            <label class="lbl-label">
                                                Employee Code (This will use as password)
                                            </label>
                                        </div>
                                    </div>

                                    <div class="col-md-6 col-lg-6 mb-2 mt-3">
                                        <div style="padding-left: 5px; display: inline-flex; color: black">
                                            <label class="col-form-label" style="font-weight: 700;">
                                                Gender
                                                <span style="color:rgba(255, 0, 0, 0.78)">*</span>
                                            </label>
                                            <div style="margin: 7px 6px 2px 6px">
                                                <vs-radio v-model="gender" vs-name="radios1" vs-value="male">Male</vs-radio>
                                            </div>
                                            <div style="margin: 7px 6px 2px 6px">
                                                <vs-radio v-model="gender" vs-name="radios1" vs-value="female">Female</vs-radio>
                                            </div>
                                            <div style="margin: 7px 6px 2px 6px">
                                                <vs-radio v-model="gender" vs-name="radios1" vs-value="rather not say">Rather not say</vs-radio>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <input type="hidden" v-model="userId" />
                            <input type="hidden" v-model="primaryUserId" />
                            <div class="form-group">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <b-button type="submit" class="save-btn" variant="primary">Update</b-button>
                                        <b-button v-if="!isForm" @click="closeEditForm" variant="outline-info">Cancel</b-button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </b-card>
                    <div class="table-responsive">
                        <div class="col-sm-12">
                            <b-card>
                                <div class="form-group">
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <table class="table table-hover">
                                                <tr>
                                                    <th>Sr#</th>
                                                    <th>Facilitator Name</th>
                                                    <th>CNIC</th>
                                                    <th>Contact Number</th>
                                                    <th>Email</th>
                                                    <th>Action</th>
                                                </tr>

                                                <tr v-for="(
                                                item, index
                                              ) in newTrainer" v-bind:key="item.trainer.id">
                                                    <td>{{ index + 1 }}</td>
                                                    <td v-if="item.trainer.name != null" class="text-capitalize">
                                                        {{ item.trainer.name }}
                                                    </td>
                                                    <td v-else>--</td>
                                                    <td v-if="item.trainer.cnic != null">
                                                        {{ item.trainer.cnic }}
                                                    </td>
                                                    <td v-else>--</td>

                                                    <td v-if="
                                                  item.trainer.mobile != null
                                                ">
                                                        {{ item.trainer.mobile }}
                                                    </td>
                                                    <td v-else>--</td>
                                                    <td v-if="
                                                  item.trainer.email != null
                                                ">
                                                        {{ item.trainer.email }}
                                                    </td>
                                                    <td v-else>--</td>
                                                    
                                                    <td>
                                                        <a @click="
                                                    editRecord(item.trainer.id)
                                                  ">
                                                            <vs-icon class="mr-1" icon="edit" style="
                                                      color: #007bff;
                                                      font-size: 20px;
                                                      font-weight: 600;
                                                      cursor: pointer;
                                                    "></vs-icon>
                                                        </a>
                                                        <a @click="
                                                    unassignedTraining(
                                                      item.trainer.id
                                                    )
                                                  ">
                                                            <vs-icon class="mr-1" icon="clear" style="
                                                      color: #ff0000c7;
                                                      font-size: 20px;
                                                      font-weight: 600;
                                                      cursor: pointer;
                                                    "></vs-icon>
                                                        </a>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </b-card>
                        </div>
                    </div>
                </div>
            </vs-tab>
            <vs-tab label="Registered Facilitators'">
                <div class="table-responsive">
                    <div class="col-sm-12">
                        <b-card>
                            <div class="form-group">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="col-sm-4 float-left mb-2 p-0">
                                            <input type="text" placeholder="Search ..." v-model="searchQuery" class="search_button form-control form-control-sm" @keyup.enter="filterData" @input="callSearch" />
                                            <button class="clear_button" @click="getAllTraining" type="button">
                                                Search
                                            </button>
                                            <i v-if="searchQuery !== ''" class="material-icons close_icon" @click="clearSearch">close</i>
                                        </div>
                                        <div class="col-sm-4 float-right mb-2 p-0">
                                            <Pagination :current-page="currentPage" :record-limit="recordLimit" :total-counts="totalCounts" @prev-page="prevPage" @next-page="nextPage" @go-to-page="goToPage" />
                                            <div class="page-count">
                                                {{((currentPage-1)*50)+registeredTrainerArr.length}}
                                                Records out of
                                                {{this.totalCounts}}
                                            </div>
                                        </div>

                                        <table class="table table-hover">
                                            <tr style="color: #000 !important">
                                                <th>Sr#</th>
                                                <th>Facilitator Name</th>
                                                <th>CNIC</th>
                                                <th>Email</th>
                                                <th>Contact Number</th>
                                                <th>Action</th>
                                            </tr>

                                            <tr v-for="(item, index) in registeredTrainerArr" v-bind:key="item.id">
                                                <td>{{ index + 1 + offSet }}</td>
                                                <td v-if="item.name != null" class="text-capitalize">
                                                    {{ item.name }}
                                                </td>
                                                <td v-else>--</td>
                                                <td v-if="item.cnic != null">
                                                    {{ item.cnic }}
                                                </td>
                                                <td v-else>--</td>

                                                <td v-if="item.email != null">
                                                    {{ item.email }}
                                                </td>
                                                <td v-else>--</td>
                                                <td v-if="item.mobile != null">
                                                    {{ item.mobile }}
                                                </td>
                                                <td v-else>--</td>

                                                <td v-if="item.status == 'found'">
                                                    <span>
                                                        <a @click="
                                                    unassignedTraining(item.id)
                                                  ">
                                                            <vs-chip color="danger">Un Select</vs-chip>
                                                        </a>
                                                    </span>
                                                </td>
                                                <td v-else>
                                                    <a @click="
                                                  assignedTraining(item.id)
                                                ">
                                                        <vs-chip color="success">Select for Training</vs-chip>
                                                    </a>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </b-card>
                        <!-- new form popup ends -->
                    </div>
                </div>
            </vs-tab>
        </vs-tabs>

        <!-- row 1 starts  -->
    </fieldset>
</div>
</template>

<script>
import Selectize from "vue2-selectize";
import axios from "axios";
import Pagination from '../../../../components/Pagination.vue';

export default {
    data: () => ({
        currentPage: 1,
        recordLimit: 50,
        totalCounts: 0,
        offSet: 0,
        searchQuery: "",
        isSidebar: false,
        isEditForm: false,
        whichSelect: 0,
        passport: "",
        trainingId: "",
        trainingCode: "",
        valuesArray: [],
        updateTraining: [],

        radios1: "",
        gender: "",
        success: "",
        inValid: [],
        isForm: true,
        isFormData: false,
        tabIndex: 0,
        contact_person: "",
        contact_number: "",
        contact_email: "",
        address: "",
        options: {
            format: "DD/MM/YYYY",
            useCurrent: false,
        },
        
        tag: "",
        mobilenumber: "",
        cnic: "",
        name: "",
        email: "",
        tags: [],
        role: "",
        rolesArr: [],
        roleuser: "",
        primaryUserId: "",
        nationality: "",
        academicqualifications: "",
        department: null,
        departmentArr: [],
        departmentSetting: {
            maxItems: 1,
            searchField: ["title"],
            plugins: ["remove_button"],
            placeholder: "Select department here"
        },
        designation: null,
        designationArr: [],
        designationSetting: {
            maxItems: 1,
            searchField: ["title"],
            plugins: ["remove_button"],
            placeholder: "Select designation here"
        },
        checkTraining: [],
        sessionByArray: [],
        textarea: "",
        mydate: "",
        startDate: "",
        endDate: "",
        code: "",
        countryArr: [],
        provinceArr: [],
        districtArr: [],
        nationalityArr: [],
        qualificationArr: [],
        degreenameArr: [],
        newTrainer: [],
        registeredTrainerArr: [],
        training_status: "",

    }),
    components: {
        Pagination,
        Selectize
    },

    mounted() {
        axios.defaults.headers["Authorization"] = localStorage.getItem("token");
        this.trainingCode = this.$route.query.trainingId;

        //Select all countries

        this.openLoading();
        axios
            .get(
                localStorage.getItem("BASE_PATH") +
                "/programOfficer/trainingsingle/get/" +
                this.trainingCode
            )
            .then((response) => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg(
                        "Your are Unauthorized. Need to Login Again"
                    );
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.updateTraining = response.data.training;
                this.trainingId = response.data.training.id;
                this.training_status = response.data.training.trainingstatus;
                this.allTrainer();
                this.getTrainerTraning();
                this.getAllTraining();

            });
        axios
            .get(localStorage.getItem("BASE_PATH") + "/countries/get")
            .then((response) => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg(
                        "Your are Unauthorized. Need to Login Again"
                    );
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.countryArr = response.data;
            });
        //get result of trainers
        axios
            .get(localStorage.getItem("BASE_PATH") + "/trainers/all/get")
            .then((response) => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg(
                        "Your are Unauthorized. Need to Login Again"
                    );
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.valuesArray = response.data;
            });

        //select all district
        axios
            .get(localStorage.getItem("BASE_PATH") + "/districts/get")
            .then((response) => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg(
                        "Your are Unauthorized. Need to Login Again"
                    );
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.districtArr = response.data;
            });
        //select all degree names
        axios
            .get(localStorage.getItem("BASE_PATH") + "/degreenames/get")
            .then((response) => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg(
                        "Your are Unauthorized. Need to Login Again"
                    );
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.qualificationArr = response.data;
            });
        // department
        axios
            .get(localStorage.getItem("BASE_PATH") + "/departments/get")
            .then((response) => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg(
                        "Your are Unauthorized. Need to Login Again"
                    );
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.departmentArr = response.data;
            });
        //designation
        axios
            .get(localStorage.getItem("BASE_PATH") + "/designations/get")
            .then((response) => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg(
                        "Your are Unauthorized. Need to Login Again"
                    );
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.designationArr = response.data;
            });
        axios
            .get(localStorage.getItem("BASE_PATH") + "/trainers/get")
            .then((response) => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg(
                        "Your are Unauthorized. Need to Login Again"
                    );
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.sessionByArray = response.data;
            });
        axios
            .get(localStorage.getItem("BASE_PATH") + "/trainer/role/get")
            .then((response) => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg(
                        "Your are Unauthorized. Need to Login Again"
                    );
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                // this.rolesArr = response.data;
                this.role = response.data[0].id;
            });

        // Nationality
        axios
            .get(localStorage.getItem("BASE_PATH") + "/nationalities/get")
            .then(response => {

                this.closeLoading();
                this.nationalityArr = response.data;
            });

    },
   
    methods: {
        // onclick show wizard steps

        closeEditForm() {
            this.isForm = true;
            this.isEditForm = false;
            this.resetForm();
        },
        getAllTraining() {
            axios
                .post(
                    localStorage.getItem("BASE_PATH") +
                    "/trainer/get/all/" +
                    this.trainingId, {
                        "searchText": this.searchQuery,
                        "offSet": this.offSet,
                    }
                )
                .then((response) => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg(
                            "Your are Unauthorized. Need to Login Again"
                        );
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.registeredTrainerArr = response.data.trainers;
                    this.totalCounts = response.data.totalCounts;
                    this.recordLimit = response.data.recordLimit;
                    this.offSet = response.data.offSet;
                });
        },
        assignedTraining(id) {
            this.openLoading();
            axios
                .post(
                    localStorage.getItem("BASE_PATH") + "/training/assigned/trainer", {
                        trainingId: this.updateTraining.id,
                        trainee: id,
                    }
                )
                .then((response) => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg(
                            "Your are Unauthorized. Need to Login Again"
                        );
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    if (response.data.success) {
                        this.$toasted.global.successMsg("Assigned Training successfully!");
                        this.getAllTraining();
                        this.allTrainer();
                    }
                });
        },
        unassignedTraining(id) {
            this.openLoading();
            axios
                .post(
                    localStorage.getItem("BASE_PATH") + "/training/un-assigned/trainer", {
                        trainingId: this.updateTraining.id,
                        trainee: id,
                    }
                )
                .then((response) => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg(
                            "Your are Unauthorized. Need to Login Again"
                        );
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    if (response.data.success) {
                        this.$toasted.global.successMsg(
                            "Training Un Assigned successfully!"
                        );
                        this.getAllTraining();
                        this.allTrainer();
                    }
                });
        },

        editRecord(id) {
            this.isForm = false;
            this.isEditForm = true;
            this.openLoading();
            axios
                .get(
                    localStorage.getItem("BASE_PATH") + "/trainer/user/" + id + "/edit"
                )
                .then((response) => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg(
                            "Your are Unauthorized. Need to Login Again"
                        );
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    if (response) {
                        this.name = response.data.name;
                        this.code = response.data.trainer_user_id.code;
                        this.mobilenumber = response.data.mobile;
                        this.email = response.data.email;
                        this.gender = response.data.gender;
                        this.cnic = response.data.cnic;
                        this.passport = response.data.passport;
                        this.primaryUserId = response.data.trainer_id_user;
                        this.userId = id;
                        this.nationality = response.data.nationality;
                        this.address = response.data.address;
                        this.academicqualifications = response.data.academicqualifications;
                        this.designation = response.data.trainer_user_id.designation_id;
                        this.department = response.data.trainer_user_id.department_id;
                        // this will scrollTop to edit form
                        window.scrollTo(0, 0);
                    }
                });
        },
        deleteRecord(id) {
            this.$bvModal
                .msgBoxConfirm("Please confirm that you want to delete?", {
                    title: "Please Confirm",
                    size: "sm",
                    buttonSize: "sm",
                    okVariant: "danger",
                    okTitle: "Delete",
                    cancelTitle: "Cancel",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    if (value == true) {
                        this.openLoading();
                        axios
                            .post(localStorage.getItem("BASE_PATH") + "/trainer/delete", {
                                id: id,
                            })
                            .then((response) => {
                                this.closeLoading();
                                if (response.data.success) {
                                    this.$toasted.global.successMsg(
                                        "Record has been deleted successfully!"
                                    );
                                    this.allTrainer();
                                } else if (response.data.error) {
                                    throw response.data.error;
                                }
                            })
                            .catch((error) => {
                                this.$toasted.global.errorMsg(error);
                            });
                    }
                });
        },
        getTrainerTraning: function getAllTraining() {
            axios
                .get(
                    localStorage.getItem("BASE_PATH") +
                    "/all/trainer/training/get/" +
                    this.trainingId
                )
                .then((response) => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg(
                            "Your are Unauthorized. Need to Login Again"
                        );
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    // this.rolesArr = response.data;
                    this.checkTraining = response.data;
                });
        },

        allTrainer: function allTrainer() {
            this.openLoading();
            axios
                .get(
                    localStorage.getItem("BASE_PATH") +
                    "/trainer/show/training/" +
                    this.trainingId
                )
                .then((response) => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg(
                            "Your are Unauthorized. Need to Login Again"
                        );
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.newTrainer = response.data;
                });
        },
        openLoading() {
            this.$vs.loading({
                type: "material",
            });
        },
        closeLoading() {
            this.$vs.loading.close();
        },
        toastSuccess(msg) {
            this.$bvToast.toast(msg, {
                title: "Success",
                autoHideDelay: 10000,
                variant: "success",
                solid: true,
            });
        },
        toastError(msg) {
            this.$bvToast.toast(msg, {
                title: "Error",
                autoHideDelay: 10000,
                variant: "danger",
                solid: true,
            });
        },
        showinputvalue: function (event) {
            this.name = event.target.value;
        },
        //Quick training
        quickRegistration(e) {
            e.preventDefault();
            this.inValid = [];
            if (!this.name) {
                this.inValid.push("Name is required.");
            }

            if (!this.email) {
                this.inValid.push("Email is required.");
            } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)) {
                this.inValid.push("Invalid email format.");
            }
            if (!this.gender) {
                this.inValid.push("Gender is required.");
            }
            if (!this.nationality) {
                this.inValid.push("Nationality is required.");
            }
            if (this.nationality == 1) {
                var cnic_var = this.cnic;
                if (cnic_var == '') {
                    this.inValid.push("CNIC is required.");
                } else {
                    if (cnic_var != null && cnic_var != undefined && cnic_var != "") {
                        cnic_var = cnic_var.replace(/_/g, "");
                        if (cnic_var.length < 17) {
                            this.inValid.push("Must be valid CNIC, 16101-1114812-3");
                        }
                    }
                }
            }
            if (!this.academicqualifications) {
                this.inValid.push("Qualifications is required.");
            }

            if (!this.code) {
                this.inValid.push("Code is required.");
            }
            var phone_no1 = this.mobilenumber;
            if (phone_no1 == null || phone_no1 == undefined || phone_no1 == '') {
                this.inValid.push("Must be valid Number, 0345-9992229");
            } else {
                phone_no1 = phone_no1.replace(/_/g, "");
                if (phone_no1.length < 14 || !phone_no1.startsWith('(03')) {
                    this.inValid.push("Must be a valid number starting with '03', e.g., 0345-9992229");
                }
            }
            
            if (cnic_var != null && cnic_var != undefined && cnic_var != "") {
                cnic_var = cnic_var.replace(/_/g, "");
                if (cnic_var.length < 17) {
                    this.inValid.push("Must be valid CNIC, 16101-1114812-3");
                }
            }
            for (var i = 0; i < this.inValid.length; i++) {
                this.$toasted.global.errorMsg(this.inValid[i]);
            }

            if (!this.inValid.length) {

                let self = this;
                this.openLoading();
                axios
                    .post(
                        localStorage.getItem("BASE_PATH") +
                        "/programofficer/quick/registeration/trainer", {

                            name: this.name,
                            code: this.code,
                            role: this.role,
                            contactNo: this.mobilenumber,
                            email: this.email,
                            training_id: this.trainingId,
                            gender: this.gender,
                            nationality: this.nationality,
                            address: this.address,
                            academicqualifications: this.academicqualifications,
                            designation: this.designation,
                            department_name: this.department,

                            user_id: JSON.parse(localStorage.getItem("currentUser")).id,
                            cnic: this.cnic,
                            passport: this.passport,
                            type: "Quick Registration",
                        }
                    )
                    .then((response) => {
                        this.closeLoading();
                        if (response.data.success) {
                            self.toastSuccess("Record has been added successfully!");
                            self.resetForm();
                            self.allTrainer();
                        } else if (response.data.error) {
                            throw response.data.error;
                        }
                    })
                    .catch((error) => {
                        self.toastError(error);
                    });
            }
        },
        submitEditForm(e) {
            e.preventDefault();
            this.inValid = [];
            if (!this.name) {
                this.inValid.push("Name is required.");
            }

            if (!this.email) {
                this.inValid.push("Email is required.");
            } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)) {
                this.inValid.push("Invalid email format.");
            }
            if (!this.gender) {
                this.inValid.push("Gender is required.");
            }
            if (!this.nationality) {
                this.inValid.push("Nationality is required.");
            }
            if (!this.code) {
                this.inValid.push("Code is required.");
            }
            if (!this.academicqualifications) {
                this.inValid.push("Qualifications is required.");
            }
            var phone_no1 = this.mobilenumber;
            if (phone_no1 == null || phone_no1 == undefined || phone_no1 == '') {
                this.inValid.push("Must be valid Number, 0345-9992229");
            } else {
                phone_no1 = phone_no1.replace(/_/g, "");
                if (phone_no1.length < 14) {
                    this.inValid.push("Must be valid Number, 0345-9992229");
                }
            }
            if (this.nationality == 1) {
                var cnic_var = this.cnic;
                if (cnic_var == '') {
                    this.inValid.push("CNIC is required.");
                } else {
                    if (cnic_var != null && cnic_var != undefined && cnic_var != "") {
                        cnic_var = cnic_var.replace(/_/g, "");
                        if (cnic_var.length < 17) {
                            this.inValid.push("Must be valid CNIC, 16101-1114812-3");
                        }
                    }
                }
            }

            for (var i = 0; i < this.inValid.length; i++) {
                this.$toasted.global.errorMsg(this.inValid[i]);
            }

            if (!this.inValid.length) {

                let self = this;
                this.openLoading();
                axios
                    .post(localStorage.getItem("BASE_PATH") + "/trainer/update", {

                        name: this.name,
                        code: this.code,
                        role: this.role,
                        contactNo: this.mobilenumber,
                        email: this.email,
                        gender: this.gender,
                        nationality: this.nationality,
                        address: this.address,
                        academicqualifications: this.academicqualifications,
                        designation: this.designation,
                        department_name: this.department,
                        //insert trainee quick information in trainee table
                        user_id: JSON.parse(localStorage.getItem("currentUser")).id,
                        cnic: this.cnic,
                        passport: this.passport,
                        type: "Quick Registration",
                        id: this.userId,
                        primaryUserId: this.primaryUserId,
                    })

                    .then((response) => {
                        this.closeLoading();
                        if (response.data.success) {
                            self.toastSuccess("Record has been updated successfully!");
                            self.resetForm();
                            self.allTrainer();

                            this.isForm = true;
                            this.isEditForm = false;
                        } else if (response.data.error) {
                            throw response.data.error;
                        }
                    })
                    .catch((error) => {
                        self.toastError(error);
                    });
            }
        },
        resetForm() {
            this.name = "";
            this.cnic = "";
            this.code = "";
            this.passport = "";
            this.gender = "";
            this.mobilenumber = "";
            this.email = "";
            this.country = "";
            this.province = "";
            this.district = "";
            this.address = "";
            this.department = "";
            this.designation = "";
            this.certificate = "";
            this.passing_year = "";
            this.institute = "";
            this.training_name = "";
            this.training_code = "";
            this.nationality = "";
            this.academicqualifications = "";
        },
        successUpload() {
            this.$vs.notify({
                color: "primary",
                title: "Upload Success",
                text: "Your file is uploaded Successfully.",
            });
        },
        showForm() {
            this.isForm = false;
            this.isFormData = true;
        },
        prevPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
                this.offSet = this.currentPage * 50 - 50
                this.getAllTraining();
            }
        },
        nextPage() {
            if (this.currentPage * this.recordLimit < this.totalCounts) {
                this.currentPage++;
                this.offSet = this.currentPage * 50 - 50
                this.getAllTraining();
            }
        },
        goToPage(page) {
            this.currentPage = page;
            this.offSet = this.currentPage * 50 - 50
            this.getAllTraining();
        },
        filterData() {
            this.currentPage = 1
            this.offSet = 0
            this.getAllTraining();
        },
        clearSearch() {
            this.currentPage = 1
            this.offset = 0
            this.searchQuery = ""
            this.getAllTraining();
        },
        callSearch() {
            if (this.searchQuery.length == 0) {
                this.getAllTraining();
            }
        },

    },

};
</script>

<style scoped>
#msform {
    text-align: center;
    position: relative;
    margin-top: 20px;
}

#msform fieldset .form-card {
    background: white;
    border: 0 none;
    border-radius: 0px;
    box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.2);
    padding: 20px 40px 30px 40px;
    box-sizing: border-box;
    width: 94%;
    margin: 0 3% 20px 3%;
    position: relative;
}

#msform fieldset {
    padding: 10px;
    background: #f4f4f4;
    border: 0 none;
    border-radius: 2rem;
    box-sizing: border-box;
    width: 100%;
    margin: 0;
    border: 2px solid #ccc;
    padding-bottom: 20px;
    position: relative;
}

#msform fieldset:not(:first-of-type) {
    display: none;
}

#msform fieldset .form-card {
    text-align: left;
    color: #9e9e9e;
}

#msform .action-button {
    width: 100px;
    background: skyblue;
    font-weight: bold;
    color: white;
    border: 0 none;
    border-radius: 0px;
    cursor: pointer;
    padding: 10px 5px;
    margin: 10px 5px;
}

#msform .action-button:hover,
#msform .action-button:focus {
    box-shadow: 0 0 0 2px white, 0 0 0 3px skyblue;
}

#msform .action-button-previous {
    width: 100px;
    background: #616161;
    font-weight: bold;
    color: white;
    border: 0 none;
    border-radius: 0px;
    cursor: pointer;
    padding: 10px 5px;
    margin: 10px 5px;
}

#msform .action-button-previous:hover,
#msform .action-button-previous:focus {
    box-shadow: 0 0 0 2px white, 0 0 0 3px #616161;
}

select.list-dt {
    border: none;
    outline: 0;
    border-bottom: 1px solid #ccc;
    padding: 2px 5px 3px 5px;
    margin: 2px;
}

select.list-dt:focus {
    border-bottom: 2px solid skyblue;
}

.card {
    z-index: 0;
    border: none;
    border-radius: 0.5rem;
    position: relative;
}

.fs-title {
    font-size: 25px;
    color: #2c3e50;
    margin-bottom: 10px;
    font-weight: bold;
    text-align: left;
}

.radio-group {
    position: relative;
    margin-bottom: 25px;
}

.radio {
    display: inline-block;
    width: 204;
    height: 104;
    border-radius: 0;
    background: lightblue;
    box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.2);
    box-sizing: border-box;
    cursor: pointer;
    margin: 8px 2px;
}

.radio:hover {
    box-shadow: 2px 2px 2px 2px rgba(0, 0, 0, 0.3);
}

.radio.selected {
    box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.1);
}

.fit-image {
    width: 100%;
    object-fit: cover;
}

.card-body {
    background-color: #f4f4f4 !important;
}

.vuesax-app-is-ltr .con-vs-chip {
    padding: 5px !important;
    /* padding-right: 10px; */
    cursor: pointer;
}
</style><style>
span.text-chip.vs-chip--text {
    margin-left: 0px !important;
}

.con-vs-chip.vs-chip-danger.con-color,
.con-vs-chip.vs-chip-success.con-color,
.con-vs-chip.vs-chip-warning.con-color {
    padding: 5px !important;
}

.vuesax-app-is-ltr .con-vs-chip {
    float: none !important;
}

.form-row {
    border: none !important;
    padding: 0px !important;
}

.search_button {
    position: relative
}

.clear_button {
    position: absolute;
    right: 0px;
    height: 31px;
    top: 0px;
    width: 80px;
    border-radius: 5px;
    background-color: #06a6e0;
    border: 1px solid #06a6e0;
    color: #ffffff;
    font-size: 15px;
}

.close_icon {
    position: absolute;
    right: 85px;
    top: 4px;
    color: #dc3545;
    font-weight: bold;
    cursor: pointer;
    font-size: 24px !important;
}

.page-count {
    text-align: end;
    font-size: 15px;
    color: #06a6e0;
}
</style>
